import { render, staticRenderFns } from "./CreateToken.vue?vue&type=template&id=239aee97&scoped=true&"
import script from "./CreateToken.vue?vue&type=script&lang=js&"
export * from "./CreateToken.vue?vue&type=script&lang=js&"
import style1 from "./CreateToken.vue?vue&type=style&index=1&id=239aee97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239aee97",
  null
  
)

export default component.exports